import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_config_provider = _resolveComponent("a-config-provider")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_config_provider, { theme: {
      token: {
        colorPrimary: '#00b96b',
      },
    } }, {
      default: _withCtx(() => [
        _hoisted_1,
        _createVNode(_component_a_space, { wrap: "" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_button, { type: "primary" }, {
              default: _withCtx(() => [
                _createTextVNode("Primary Button")
              ]),
              _: 1
            }),
            _createVNode(_component_a_button, null, {
              default: _withCtx(() => [
                _createTextVNode("Default Button")
              ]),
              _: 1
            }),
            _createVNode(_component_a_button, { type: "dashed" }, {
              default: _withCtx(() => [
                _createTextVNode("Dashed Button")
              ]),
              _: 1
            }),
            _createVNode(_component_a_button, { type: "text" }, {
              default: _withCtx(() => [
                _createTextVNode("Text Button")
              ]),
              _: 1
            }),
            _createVNode(_component_a_button, { type: "link" }, {
              default: _withCtx(() => [
                _createTextVNode("Link Button")
              ]),
              _: 1
            }),
            _createVNode(_component_a_radio, null, {
              default: _withCtx(() => [
                _createTextVNode("Radio")
              ]),
              _: 1
            }),
            _createVNode(_component_a_checkbox, null, {
              default: _withCtx(() => [
                _createTextVNode("Checkbox")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}